import { createRouter, createWebHashHistory } from "vue-router";
import Dashboard from "@/views/Dashboard.vue";
//import Tables from "@/views/Tables.vue";
import Statistic from "@/views/statistic/Statistic.vue"
import Devices from "@/views/devices/Devices.vue"
import MerchantList from "@/views/merchants/MerchantList.vue"
import UserList from "@/views/users/UserList.vue"
import AdministratorsTable from "@/views/administrators/AdministratorsTable.vue";
import Submission from "@/views/submission/Submission.vue";
import SubUsers from "@/views/merchants/subusers/SubUsers.vue";
import Profile from "@/views/profile/Profile.vue";
import SignIn from "@/views/SignIn.vue";
import NotFound from "@/views/NotFound.vue"; 
import store from '@/store';

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: '/login',
    component: SignIn,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/users",
    name: "Users",
    component: UserList,
  },
  {
    path: "/mechants",
    name: "Merchants",
    component: MerchantList,
  },
  {
    path: "/subusers",
    name: "SubUsers",
    component: SubUsers,
  },
  {
    path: "/submission",
    name: "Submission",
    component: Submission,
  },
  {
    path: "/statistic",
    name: "Statistic",
    component: Statistic,
  },
  {
    path: "/devices",
    name: "Devices",
    component: Devices,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/administrators",
    name: "Administrators",
    component: AdministratorsTable,
  },
  {
    path: '/logout',
    name: 'Logout',
    component:SignIn,
  },
  {
    path: "/:catchAll(.*)",  // 捕获所有未知路径
    name: "NotFound",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// 路由守卫：检查用户是否已登录
router.beforeEach((to, from, next) => {
  console.log("get token:", store.getters.token, "frompath:", from.path, "topath:", to.path)
  if (!store.getters.token && to.path != '/login' && to.path != '/profile') {
    console.log("get token false:", !store.getters.token)
    next('/login');  // 如果未登录，重定向到登录页
  } else {
    console.log("Token found, proceeding to:", to.path);
    next();  // 允许访问
  }
});


export default router;
